type DateRangeParams = {
  startDate: Date;
  days?: number;
  endDate?: Date;
};

export const calculateDateRange = (
  params: DateRangeParams,
): { endDate: Date | undefined; days: number | undefined } => {
  const { startDate, days, endDate } = params;
  let newEndDate, newDays;

  if (days && startDate) {
    let date = new Date(startDate);
    date.setDate(date.getDate() + days);

    newEndDate = date;
  }

  if (endDate && startDate) {
    const timeDiff = endDate.getTime() - startDate.getTime();
    newDays = Math.round(timeDiff / (1000 * 60 * 60 * 24));
  }

  return { endDate: newEndDate, days: newDays };
};
